<template>
  <v-navigation-drawer
    :model-value="data.getShowAdvancedPanel || data.getShowStateMachine"
    location="right"
    :scrim="false"
    elevation="10"
    temporary
    :style="
      data.getShowAdvancedPanel ? { right: '500px', width: '1000px' }
      : data.getShowStateMachine ? { right: right, width: '600px', 'max-width': '50%' }
      : { right: '0px', width: '0px' }
    "
  >
    <div class="operational custom-scrollbars shadow-editMenu">
      <v-layout class="flex-column h-100">
        <div
          class="slot-div"
          style="
            height: 100%;
            position: relative;
            top: 0px;
            overflow: auto;
            padding-left: 30px;
            padding-right: 30px;
          "
        >
        <VueFlow>
          <MiniMap v-if="data.getShowAdvancedPanel" />

          <Background :variant="BackgroundVariant.Lines" />

          <Panel position="top-right" v-if="data.getShowAdvancedPanel">
            <button type="button" @click="addRandomNode">add node</button>
          </Panel>

          <template #node-custom="{ data }">
            <CustomNode :data="data" />
          </template>
        </VueFlow>
        </div>
      </v-layout>
    </div>
  </v-navigation-drawer>
</template>

<script setup>
import { Panel, VueFlow, useVueFlow } from '@vue-flow/core'
import { Background, BackgroundVariant } from '@vue-flow/background'
import { MiniMap } from '@vue-flow/minimap'
import { dataStore } from '../../stores/data';
import { advancedAlarmStore } from './advancedAlarm';
import { alarmTemplates } from './advancedAlarmTemplate';
import CustomNode from './CustomNode.vue';
import { watch, computed } from 'vue';
import { useDisplay } from 'vuetify'

let vueInstance;

const data = dataStore();
const advancedAlarm = advancedAlarmStore();
const nameDisplay = useDisplay().name;

const { nodes, addNodes, addEdges, onConnect, setNodes, setEdges, nodesDraggable, panOnDrag, onPaneReady } = useVueFlow({
  zoomOnScroll: false, 
  zoomOnPinch: false,
  zoomOnDoubleClick: false,
  panOnScroll: false,
  preventScrolling: false,
})

onPaneReady((instance) => {
  vueInstance = instance;
})

const right = computed(() => {
  let right = "500px";
  let zoom = 1;
  switch (nameDisplay.value) {
    case 'xs':
      zoom = 0.6;
      right = "100%";
      break;
    case 'sm': 
      zoom = 0.6;
      right = "50%";
      break;
    case 'md': 
      zoom = 0.8;
      right = "50%";
      right = "500px";
      break;
  }
  vueInstance.setViewport({ x: 0, y: 0, zoom });
  return right;
});

onConnect((params) => addEdges(params))

function editState(id) {
  advancedAlarm.setEditing('state');
  advancedAlarm.setStateOnEdit(nodes.value.find(n => n.id === id))
}

function addRandomNode() {
  const nodeId = (nodes.value.length + 1).toString()
  const newNode = {
    id: nodeId,
    label: `Node: ${nodeId}`,
    position: { x: 50, y: 50 },
    type: 'custom',
    events: {
      click: () => {
        editState(nodeId);
      }
    }
  }

  addNodes([newNode])
  console.log(nodes.value)
}

function refreshStateMachine() {
  if (data.getShowStateMachine && data.getShowedState) {
      setNodes(alarmTemplates[data.getShowedState].nodes);
      setEdges(alarmTemplates[data.getShowedState].edges);
      nodesDraggable.value = false;
      panOnDrag.value = false;
    }
}

watch(
  () => data.getShowStateMachine,
  (_) => refreshStateMachine(),
)

watch(
  () => data.getShowedState,
  (_) => refreshStateMachine(),
)

</script>

